module.exports = __webpack_public_path__ + "img/prize-3.2c7d6d44.jpg";